var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.848,
    viewBox: "0 0 24 24.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36445",
    "data-name": "Path 36445",
    d: "M13.479,24.541a6.49,6.49,0,0,1-8.943-1.136A7.066,7.066,0,0,1,4.9,14.082l8.681-9.01A6.526,6.526,0,0,1,18.369,3a6.437,6.437,0,0,1,4.691,1.967,7.118,7.118,0,0,1,.7,8.907,8.376,8.376,0,0,0-2.795-.518,2.667,2.667,0,0,0-.9.1l.8-.828a3.852,3.852,0,0,0,0-5.282,3.268,3.268,0,0,0-2.5-1.243,3.561,3.561,0,0,0-2.594,1.139l-3.792,3.832,3.892,4.039a8.486,8.486,0,0,0-2.994,6.421A13.258,13.258,0,0,0,13.479,24.541ZM25.155,17.292Zm-.7-.725a5.87,5.87,0,0,0-7.722.7,6.405,6.405,0,0,0-.661,8Zm1.4,1.45-8.383,8.7a5.87,5.87,0,0,0,7.722-.7,6.405,6.405,0,0,0,.661-8ZM16.772,25.992Z",
    transform: "translate(-2.953 -2.999)",
    fill: "#e9faf9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/Thumb.49eb1ecb7bba88bc3b50260dcaad8b4f.svg";
export { ForwardRef as ReactComponent };